import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import AboutUs from "./components/aboutus/AboutUs";
import MoreServices from "./components/moreServices/MoreServices";
import CaseStudies from "./components/caseStudies/CaseStudies";
import FinalContact from "./components/finalContact/FinalContact";
import CaseStudyDetail from "./components/caseStudies/CaseStudyDetail";
import ServiceDetail from "./components/moreServices/ServiceDetail";
import WhatsappChatIcon from "./components/whatsapp/WhatsappChatIcon"; // Import WhatsApp Icon Component
import ParentComp from "./components/digitalmarketing/ParentComp";
import PrivacyPolicy from "./components/policy/PrivacyPolicy";
import TermCondition from "./components/policy/TermCondition";
import Disclaimer from "./components/policy/Disclaimer";
import RefundPolicy from "./components/policy/RefundPolicy";

const App = () => {
  return (
    <Router>
      <div>
        <Navbar />
        <div style={{ minHeight: "80vh" }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/services" element={<MoreServices />} />
            <Route path="/casestudies" element={<CaseStudies />} />
            <Route path="/courses" element={<ParentComp />} />
            <Route path="/contact" element={<FinalContact />} />
            <Route path="/case-study/:id" element={<CaseStudyDetail />} />
            <Route path="/service/:serviceTitle" element={<ServiceDetail />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy/>} />
            <Route path="/termandcondition" element={<TermCondition/>} />
            <Route path="/shippinganddeliverypolicy" element={<Disclaimer/>} />
            <Route path="/refundpolicy" element={<RefundPolicy/>} />
          </Routes>
        </div>
        <WhatsappChatIcon /> {/* Floating WhatsApp Icon */}
        <Footer />
      </div>
    </Router>
  );
};

export default App;
